import { render } from "./NoFieldsInfo.vue?vue&type=template&id=9ec4fbfa&scoped=true"
import script from "./NoFieldsInfo.vue?vue&type=script&lang=js"
export * from "./NoFieldsInfo.vue?vue&type=script&lang=js"

import "./NoFieldsInfo.vue?vue&type=style&index=0&id=9ec4fbfa&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ec4fbfa"]])

export default __exports__